import * as signalR from "@microsoft/signalr";
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ProcessHubService {
  private apiUrl = environment.urlHub +'/processHub';
  
  private hubConnection!: signalR.HubConnection;
  private processUpdatedSubject = new BehaviorSubject<{ type: string; processId: string } | null>(null);
  private notificationUpdateSubject = new BehaviorSubject<{ type: string; processId: string } | null>(null);
  private stopwatchUpdatedSubject = new BehaviorSubject<{ type: string; processId: string } | null>(null);
  private creditiesUpdatedSubject = new BehaviorSubject<{ type: string; info: string } | null>(null);
  private purchaseOrderUpdatedSubject = new BehaviorSubject<{ type: string; info: string } | null>(null);

  public processUpdated$ = this.processUpdatedSubject.asObservable();
  public notificationUpdate$ = this.notificationUpdateSubject.asObservable();
  public stopwatchUpdated$ = this.stopwatchUpdatedSubject.asObservable();
  public creditiesUpdated$ = this.stopwatchUpdatedSubject.asObservable();
  public purchaseOrderUpdated$ = this.purchaseOrderUpdatedSubject.asObservable();

  constructor() {}

  public startConnection(token: string): void {
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      //console.log('Conexão SignalR já está ativa.');
      return;
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.apiUrl, {
        accessTokenFactory: () => token, // Adiciona o token JWT
      })
      .withAutomaticReconnect() // Reconexão automática
      .build();

    this.hubConnection
      .start()
      .then(() => console.log('Conexão com SignalR estabelecida'))
      .catch(err => console.log('Erro ao estabelecer conexão com SignalR: ' + err));

    this.registerHandlers(); // Registra os eventos
  }

  public initializeConnection(): void {
    const tokenSession = localStorage.getItem('authTokenLicitaAdmin');
    //console.log('Token recebido = ' + tokenSession);
    this.startConnection(tokenSession || '');
  }

  private registerHandlers(): void {
    // Define os handlers para cada evento recebido
    this.hubConnection.on('ProcessUpdated', (type: string, processId: string) => {
      //console.log(`ProcessUpdated: ${type} - ${processId}`);
      this.processUpdatedSubject.next({ type, processId });
    });

    this.hubConnection.on('NotificationUpdate', (type: string, processId: string) => {
      //console.log(`NotificationUpdate: ${type} - ${processId}`);
      this.notificationUpdateSubject.next({ type, processId });
    });

    this.hubConnection.on('StopwatchUpdated', (type: string, processId: string) => {
      //console.log(`StopwatchUpdated: ${type} - ${processId}`);
      this.stopwatchUpdatedSubject.next({ type, processId });
    });

    this.hubConnection.on('CreditiesUpdated', (type: string, info: string) => {
      //console.log(`CreditiesUpdated: ${type} - ${info}`);
      this.creditiesUpdatedSubject.next({ type, info });
    });
    this.hubConnection.on('PurchaseOrderUpdated', (type: string, info: string) => {
      //console.log(`CreditiesUpdated: ${type} - ${info}`);
      this.purchaseOrderUpdatedSubject.next({ type, info });
    });
  }

  public stopConnection(): void {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .then(() => console.log('Conexão com SignalR encerrada'))
        .catch(err => console.log('Erro ao encerrar conexão com SignalR: ' + err));
    } else {
      //console.log('Nenhuma conexão ativa para encerrar.');
    }
  }
}
